<template>
  <q-dialog
    v-model="currentValue"
    @before-show="() => $emit('before-show')"
    @show="() => $emit('open')"
    @before-hide="() => $emit('before-hide')"
    @hide="() => $emit('hide')"
  >
    <q-card :style="{ width: width, maxWidth: maxWidth, minWidth: '400px', minHeight: minHeight }">
      <q-card-section class="row items-center">
        <div class="text-h6" v-if="title">{{ title }}</div>
        <q-space />
        <q-btn icon="close" flat round dense v-close-popup @click="onClose" />
      </q-card-section>

      <q-card-section>
        <slot />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'Dialog',
  components: {},
  props: {
    value: {
      type: [String, Number, Boolean],
    },

    title: {
      type: [String, Number],
    },

    width: {
      type: String,
      default: '600px',
    },

    minHeight: {
      type: String,
    },

    maxWidth: {
      type: String,
      default: '80vw',
    },
  },
  data() {
    return {
      progress: false,
    };
  },
  computed: {
    currentValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('submit');
    },

    onClose() {
      this.currentValue = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
